import React from 'react'
import styles from "./Styles/Search.module.css"
import {AiOutlineSearch} from "react-icons/ai"

export default function Search(props) {
  return (
    <div className={styles.search}>
        <input {...props} />
        <div className={styles.searchIcon}>
        <AiOutlineSearch size={22} color="#4E616C" />
        </div>
    </div>
  )
}
